export const SUCCESS = 'success'
export const ERROR = 'error'
export const WARNING = 'warning'
export const INFO = 'info'

export type toasterStatus = 'success' | 'error' | 'warning' | 'info'
